interface CalculateBaseAmountParams {
  hours: string;
  rate: string;
  fallbackHours?: string | number;
  fallbackRate?: string | number;
}

export const calculateBaseAmount = ({
  hours,
  rate,
  fallbackHours,
  fallbackRate,
}: CalculateBaseAmountParams) => {
  const parsedHours = parseFloat(hours || String(fallbackHours) || "0");
  const parsedRate = parseFloat(rate || String(fallbackRate) || "0");

  return parseFloat((parsedHours * parsedRate).toFixed(2));
};
